import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import {
  GIFTS_BY_INTEREST,
  GIFTS_BY_OCCASION,
  GIFTS_BY_RECIPIENT,
  GIFTS_BY_TYPE,
} from '../../config/constants/gifts';
import MerchandisingModule from '../category/MerchandisingModule';
import PopularGiftsListItem from './PopularGiftsListItem';

const PopularGiftsList = ({ popularGiftsData }) => {
  const router = useRouter();
  const giftsByInterest = popularGiftsData?.interest;

  const giftsByOccasion = popularGiftsData?.occasion;

  const giftsByType = popularGiftsData?.type;

  const giftsByRecipient = popularGiftsData?.recipient;

  const occasion = {
    subTitle:
      'From weddings and birthdays to engagements and baby showers, whatever the occasion, you’re sure to find the perfect gift to give that special someone here on Wowcher!',
    title: GIFTS_BY_OCCASION,
  };

  const recipient = {
    subTitle:
      'If you’re looking for a gift for someone in particular, maybe your sister, your grandma or your 10 year old brother, we’ve got a wide range of gifts that will be ideal for them!',
    title: GIFTS_BY_RECIPIENT,
  };

  const type = {
    subTitle:
      'Treat that special someone to a different type of gift. Our range includes letterbox gifts, gift sets and gift hampers, so you’re sure to find the perfect one for that special someone!',
    title: GIFTS_BY_TYPE,
  };

  const interest = {
    subTitle:
      'Surprise them with a gift that fits their interests. Whether they’re a keen gardener, an avid artist or a Harry Potter fanatic, you’re sure to find the perfect gift for them here.',
    title: GIFTS_BY_INTEREST,
  };

  return (
    <div className="popular-locations">
      <PopularGiftsListItem
        listItem={giftsByRecipient}
        subTitle={recipient.subTitle}
        title={recipient.title}
        toggleText={GIFTS_BY_RECIPIENT}
      />
      <PopularGiftsListItem
        listItem={giftsByOccasion}
        subTitle={occasion.subTitle}
        title={occasion.title}
        toggleText={GIFTS_BY_OCCASION}
      />
      <MerchandisingModule path={router.asPath} position={1} />
      <PopularGiftsListItem
        listItem={giftsByType}
        subTitle={type.subTitle}
        title={type.title}
        toggleText={GIFTS_BY_TYPE}
      />
      <PopularGiftsListItem
        listItem={giftsByInterest}
        subTitle={interest.subTitle}
        title={interest.title}
        toggleText={GIFTS_BY_INTEREST}
      />
      <MerchandisingModule path={router.asPath} position={2} />
      <br />
    </div>
  );
};

PopularGiftsList.propTypes = {
  popularGiftsData: PropTypes.array,
};
export default PopularGiftsList;
